import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import { FormattedMessage, injectIntl } from 'react-intl';
// Locale
import messages from '../../locale/jsonMessages';
import showToaster from '../../helpers/toasterMessages/showToaster';
//Images
import googleIcon from '/public/SiteIcons/googleIcon.svg';

import cs from '../../components/commonStyle.css';
import s from './SocialLogin.css';
function SocialLogin(props) {

  const handleClick = (event) => {
    const { isAdmin } = props;
    if (isAdmin) {
      showToaster({ messageId: 'isAdmin', toasterType: 'error' })
      event.preventDefault();
    }
  }

  const { refer } = props;
  let GoogleURL = '/login/google';
  if (refer) {
    GoogleURL = '/login/google?refer=' + refer;
  }

  return (
    <div className={cx(s.displayFlex, s.center)}>
      <a className={cx(s.displayFlex, cs.siteTextColor, cs.commonMediumText, cs.textDecorationNone)} onClick={(event) => handleClick(event)} href={GoogleURL}>
        <img src={googleIcon} className={'iconGap'} />
        <FormattedMessage {...messages.google} />
      </a>
    </div>
  );
}

SocialLogin.propTypes = {
  formatMessage: PropTypes.any,
  refer: PropTypes.string
};

const mapState = state => ({
  isAdmin: state.runtime && state.runtime.isAdminAuthenticated,
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(SocialLogin)));